import { useState } from 'react'
import './activism-page.css'
import ActivismPhotoArchive from '../components/screens/activism/photoArchive/ActivismPhotoArchive'

import imgManifiesto from '../assets/img/manifiesto-palestina.png'
import activismGuide from '../assets/img/activism-2.png'
import campaignMenopausia from '../assets/img/campaign-menopausia.png'
import rightsHands from '../assets/img/rights-hands.png'
import posicionamientoRed from '../assets/img/posicionamiento-red.png'
import accionPuntoRojoBarcelona from '../assets/img/accion-punto-rojo-barcelona-8m-2026.jpeg'
import diaInternacionalSaludMenstrual from '../assets/img/dia-internacional-salud-menstrual.jpg'
import pronunciamientoSolidaridad from '../assets/img/pronunciamiento-solidaridad.png'
import adhesionMenarquia from '../assets/img/adhesion-día-internacional-menarquia.png'
import eticaFeministaEncuentrosTerritorio from '../assets/img/etica-feminista-encuentros-territorio .png'
import manifestoJusticia from '../assets/img/manifiesto.png'
import saludMenstrualPdf from '../assets/files/salud-menstrual.pdf'

const GATED_DOCUMENT_SLUG = 'solicitud-menopausia-climaterio'
const GATED_DOCUMENT_GUIA_SLUG = 'guia-activismo-menstrual'
const GATED_DOCUMENT_RIGHTS_SLUG = 'derechos-menstruales-ley-organica'

const pillars = [
  {
    title: 'Transformación de las narrativas hegemónicas',
    content: 'Desafiamos y erradicamos el estigma, el silencio y la vergüenza que históricamente han rodeado a la menstruación, convirtiendo lo íntimo en una conversación política, académica y comunitaria.'
  },
  {
    title: 'Menstruación, ciclo y menopausia',
    content: 'Impulsamos su presencia en la agenda pública y en los diálogos cotidianos para avanzar en atención sanitaria integral, justicia ecosocial y erradicar tabúes inferiorizantes.'
  },
  {
    title: 'Reivindicación de derechos humanos',
    content: 'Entendemos la menstruación como una cuestión de derechos humanos, exigiendo a los Estados garantizar acceso equitativo a educación, salud y productos de gestión menstrual.'
  },
  {
    title: 'Incidencia política y legislativa',
    content: 'Impulsamos la aplicación de la Ley Orgánica 1/2023 para que las políticas de equidad y dignidad menstrual se implementen de forma efectiva en todos los territorios.'
  },
  {
    title: 'Altavoz de violencias en salud sexual y reproductiva',
    content: 'Amplificamos a colectivos afectados por endometriosis, el dispositivo Essure y otras violencias médicas y farmacéuticas.'
  },
  {
    title: 'Acción pública y visibilización',
    content: 'Generamos sensibilización urbana mediante acciones como los Puntos Rojos.'
  },
  {
    title: 'Postura crítica y anticapitalista',
    content: 'Cuestionamos la instrumentalización de la menstruación por parte de multinacionales, denunciamos el marketing rosa y el menowashing vinculado a la menopausia.'
  },
  {
    title: 'Producción de conocimiento y ciberactivismo',
    content: 'Desarrollamos investigación feminista situada y mejoramos la representación de la educación y la salud menstrual en Wikipedia.'
  },
  {
    title: 'Activismo colectivo e internacional',
    content: 'Tejemos redes con entidades y colectivos de otros territorios y participamos en campañas como #MenstrualMattersEU y #DiaMundialMenarquia.'
  }
]
 
const resources = [
  {
    title: 'Manifiesto por Palestina',
    buttonLabel: 'Quiero leer',
    href: `${process.env.PUBLIC_URL}/pdfs/manifiesto-palestina.pdf`,
    image: imgManifiesto,
    imageAlt: 'Manifiesto por Palestina',
    tag: 'Manifiesto'
  },
  {
    title: 'Guía Activismo Menstrual',
    buttonLabel: 'Obtener documento',
    href: `${process.env.PUBLIC_URL}/pdfs/guia.pdf`,
    image: activismGuide,
    imageAlt: 'Guía de activismo menstrual',
    tag: 'Guía',
    gated: true,
    documentSlug: GATED_DOCUMENT_GUIA_SLUG
  },
  {
    title: 'Campaña de solicitud de Atención Sanitaria en Menopausia y Climaterio',
    buttonLabel: 'Obtener documento',
    href: `${process.env.PUBLIC_URL}/pdfs/solicitud.pdf`,
    image: campaignMenopausia,
    imageAlt: 'Campaña de solicitud de Atención Sanitaria en Menopausia y Climaterio',
    tag: 'Campaña',
    gated: true,
    documentSlug: GATED_DOCUMENT_SLUG
  },
  {
    title: 'Derechos Menstruales en la Ley Orgánica 1/2023',
    buttonLabel: 'Obtener documento',
    href: `${process.env.PUBLIC_URL}/pdfs/rights.pdf`,
    image: rightsHands,
    imageAlt: 'Derechos Menstruales',
    tag: 'Marco legal',
    gated: true,
    documentSlug: GATED_DOCUMENT_RIGHTS_SLUG
  },
  {
    title: 'Salud durante la menstruación y acción pública',
    buttonLabel: 'Leer documento',
    href: saludMenstrualPdf,
    image: accionPuntoRojoBarcelona,
    imageAlt: 'Acción pública por la salud menstrual',
    tag: 'Pronunciamiento'
  },
  {
    title: 'Posicionamiento Estrategia Nacional (México)',
    buttonLabel: 'Leer posicionamiento',
    href: `${process.env.PUBLIC_URL}/pdfs/posicionamiento-red.pdf`,
    image: posicionamientoRed,
    imageAlt: 'Red Internacional de Educación Menstrual',
    tag: 'Posicionamiento'
  },
  {
    title: 'Día Internacional de la Salud Menstrual',
    buttonLabel: 'Leer pronunciamiento',
    href: `${process.env.PUBLIC_URL}/pdfs/dia-internacional-salud-menstrual.pdf`,
    image: diaInternacionalSaludMenstrual,
    imageAlt: 'Día Internacional de la Salud Menstrual',
    tag: 'Pronunciamiento'
  },
  {
    title: '¡Solidaridad internacionalista con los pueblos en resistencia!',
    buttonLabel: 'Leer pronunciamiento',
    href: `${process.env.PUBLIC_URL}/pdfs/pronunciamiento-solidaridad.pdf`,
    image: pronunciamientoSolidaridad,
    imageAlt: 'Pronunciamiento Solidaridad internacionalista',
    tag: 'Pronunciamiento'
  },
  {
    title: 'Por una ética feminista de los encuentros en el territorio',
    buttonLabel: 'Leer documento',
    href: `${process.env.PUBLIC_URL}/pdfs/etica-feminista-encuentros-territorio.pdf`,
    image: eticaFeministaEncuentrosTerritorio,
    imageAlt: 'Ética feminista de los encuentros',
    tag: 'Ética feminista'
  },
  {
    title: 'Día Internacional de la Menarquia (28 de octubre)',
    buttonLabel: 'Leer adhesión',
    href: `${process.env.PUBLIC_URL}/pdfs/adhesion-día-internacional-menarquia.pdf`,
    image: adhesionMenarquia,
    imageAlt: 'Día Internacional de la Menarquia',
    tag: 'Adhesión'
  },
  {
    title: 'Justicia menstrual\n¡IVA superreducido ya!',
    buttonLabel: 'Leer manifiesto',
    href: `${process.env.PUBLIC_URL}/pdfs/Manifiesto_Justicia_Menstrual.pdf`,
    image: manifestoJusticia,
    imageAlt: 'Justicia Menstrual',
    tag: 'Manifiesto'
  }
]

const ActivismPage = () => {
  const [activeResource, setActiveResource] = useState(null)
  const [isMenstruationNoteOpen, setIsMenstruationNoteOpen] = useState(false)
  const [email, setEmail] = useState('')
  const [acceptedPrivacy, setAcceptedPrivacy] = useState(false)
  const [error, setError] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const closeModal = () => {
    setActiveResource(null)
    setEmail('')
    setAcceptedPrivacy(false)
    setError('')
    setIsSubmitting(false)
  }

  const openModal = (resource) => {
    setActiveResource(resource)
    setEmail('')
    setAcceptedPrivacy(false)
    setError('')
  }

  const handleSubmit = async (event) => {
    event.preventDefault()

    const normalizedEmail = email.trim()

    if (!normalizedEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail)) {
      setError('Debes indicar un email válido')
      return
    }

    if (!acceptedPrivacy) {
      setError('Debes aceptar la política de privacidad')
      return
    }

    setIsSubmitting(true)
    setError('')

    try {
      const response = await fetch('/api/document-request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: normalizedEmail,
          acceptedPrivacy: true,
          documentSlug: activeResource.documentSlug,
          sourcePage: window.location.pathname || '/'
        })
      })
      const payload = await response.json()

      if (!response.ok) {
        throw new Error(payload.error || 'No se pudo guardar tu solicitud')
      }

      closeModal()
      window.open(payload.downloadUrl, '_blank', 'noopener,noreferrer')
    } catch (requestError) {
      setError(requestError.message || 'No se pudo guardar tu solicitud')
      setIsSubmitting(false)
    }
  }

  return (
    <section className='activism-page'>
      <a className='activism-page__back-link' href='/asociacion'>
        <span aria-hidden='true'>←</span>
        Volver
      </a>

      <header className='activism-page__hero'>
        <div className='activism-page__hero-copy'>
          <span className='activism-page__eyebrow'>Eje de intervención</span>
          <h1>Activismo menstrual</h1>
          <p>
            Para la Asociación La Vida en Rojo, el activismo menstrual es una práctica política para visibilizar y transformar nuestras realidades, situando la ciclicidad, la salud sexual y (no)reproductiva y los derechos menstruales y climatéricos en el centro de la agenda pública.
          </p>
        </div>

        <div className='activism-page__poster' aria-label='Imagen de activismo menstrual'>
          <img src={activismGuide} alt='Guía de activismo menstrual' />
          <span>lo íntimo también es político</span>
        </div>
      </header>

      <section className='activism-page__manifesto' aria-label='Declaración de activismo'>
        <p>
          Ponemos la educación, la salud y la cultura menstrual en los diálogos cotidianos y en la agenda política y social, porque siguen atravesadas por silencios, tabúes y estigmas que configuran de manera desigual las experiencias de las niñas, mujeres y personas que menstrúan.
          <button
            type='button'
            className='activism-page__footnote-toggle'
            aria-expanded={isMenstruationNoteOpen}
            aria-controls='activism-menstruation-note'
            onClick={() => setIsMenstruationNoteOpen(!isMenstruationNoteOpen)}
          >
            *
          </button>
          {isMenstruationNoteOpen && (
            <span id='activism-menstruation-note' className='activism-page__footnote'>
              La condición de menstruar no determina la identidad de género ni la capacidad reproductiva. Del mismo modo, los derechos sexuales, reproductivos y no reproductivos corresponden a las personas a lo largo del curso de vida, con independencia de que menstrúen, tengan capacidad de gestar o se encuentren en una determinada etapa vital. Texto aportado por Carolina Ackermann
            </span>
          )}
        </p>
      </section>

      <section className='activism-page__pillars' aria-label='Pilares del activismo menstrual'>
        <h2 className='activism-page__pillars-title'>Nuestros ámbitos de acción</h2>
        {pillars.map((pillar, index) => (
          <article className='activism-page__pillar' key={pillar.title}>
            <span>{String(index + 1).padStart(2, '0')}</span>
            <h2>{pillar.title}</h2>
            <p>{pillar.content}</p>
          </article>
        ))}
      </section>

      <section className='activism-page__resources' aria-labelledby='activism-resources-title'>
        <div className='activism-page__section-heading'>
          <span className='activism-page__eyebrow'>Materiales y campañas</span>
          <h2 id='activism-resources-title'>Documentos para activar conversaciones y derechos</h2>
        </div>

        <div className='activism-page__resource-grid'>
          {resources.map((resource) => (
            <article className='activism-page__resource' key={resource.title}>
              {resource.image && <img src={resource.image} alt={resource.imageAlt} />}
              <div>
                <span>{resource.tag}</span>
                <h3>{resource.title}</h3>
                {resource.gated ? (
                  <button type='button' className='main__button main__button--alt' onClick={() => openModal(resource)}>
                    {resource.buttonLabel}
                  </button>
                ) : (
                  <a className='main__button main__button--alt' href={resource.href} target='_blank' rel='noreferrer'>
                    {resource.buttonLabel}
                  </a>
                )}
              </div>
            </article>
          ))}
        </div>
      </section>

      <ActivismPhotoArchive />

      <section className='activism-page__join'>
        <a href='/hazte-amiga' className='main__button main__button--alt'>
          Súmate con nosotras →
        </a>
      </section>

      {activeResource ? (
        <div className='activism-page__modal' role='dialog' aria-modal='true' aria-labelledby='activism-download-title'>
          <div className='activism-page__modal-panel'>
            <button type='button' className='activism-page__modal-close' onClick={closeModal} aria-label='Cerrar'>
              ×
            </button>
            <span className='activism-page__eyebrow'>Documento descargable</span>
            <h2 id='activism-download-title'>{activeResource.title}</h2>
            <p>Déjanos tu correo para registrar la solicitud y acceder al documento en el momento.</p>
            <form onSubmit={handleSubmit}>
              <label htmlFor='document-request-email'>Email</label>
              <input
                id='document-request-email'
                type='email'
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder='Introduce tu email'
              />
              <label className='activism-page__privacy'>
                <input
                  type='checkbox'
                  checked={acceptedPrivacy}
                  onChange={(event) => setAcceptedPrivacy(event.target.checked)}
                />
                He leído y acepto la <a href='/politicaprivacidad'>Política de Privacidad</a>
              </label>
              {error ? <p className='activism-page__error'>{error}</p> : null}
              <button type='submit' className='main__button main__button--alt' disabled={isSubmitting}>
                {isSubmitting ? 'Enviando...' : 'Descargar documento'}
              </button>
            </form>
          </div>
        </div>
      ) : null}
    </section>
  )
}

export default ActivismPage
